export const _en = {
    addButton: {
        label: "Status"
    },
    toggleDeleted: {
        label: "Show deleted data"
    },
    modal: {
        add: {
            title: "Add state"
        }
    }

};


export const _fr = {
    addButton: {
        label: "Statut"
    },
    toggleDeleted: {
        label: "Afficher les statuts archivés"
    },
    dialog: {
        add: {
            title: "Ajout d'un statut"
        }
    }
};